
        <div class="space-y-2">
            <label *ngIf="!hideLabel" class="text-sm font-medium text-slate-700">{{ label }}</label>
            <div class="relative">
                <div class="grid w-full min-w-0 grid-cols-1 rounded-lg border border-slate-200 bg-white shadow-sm focus-within:border-[#6e9bad] focus-within:ring-2 focus-within:ring-[#6e9bad]/20 sm:grid-cols-[minmax(4.75rem,6rem)_minmax(0,1fr)]" [class.opacity-60]="disabled">
                    <div class="min-w-0">
                        <button
                            type="button"
                            class="flex w-full min-w-0 items-center gap-1.5 border-b border-slate-200 bg-transparent px-2 py-2.5 text-left text-slate-700 transition hover:bg-slate-50 focus:outline-none sm:h-full sm:border-b-0 sm:border-r"
                            (click)="toggleCountryMenu()"
                            (blur)="onTouched()"
                            aria-haspopup="listbox"
                            [attr.aria-expanded]="countryMenuOpen"
                            [disabled]="disabled"
                            [attr.title]="selectedCountry.name + ' ' + selectedCountry.dial_code"
                        >
                            <span class="inline-flex h-5 w-5 shrink-0 items-center justify-center text-base leading-none" aria-hidden="true">
                                {{ selectedCountry.flag }}
                            </span>
                            <span class="min-w-0 flex-1 truncate text-sm font-medium">
                                <span class="text-slate-700">{{ selectedCountry.code }}</span>
                                <span class="ml-1 text-slate-500">{{ selectedCountry.dial_code }}</span>
                            </span>
                            <svg class="h-4 w-4 shrink-0 text-slate-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.94l3.71-3.71a.75.75 0 1 1 1.06 1.06l-4.24 4.24a.75.75 0 0 1-1.06 0L5.21 8.29a.75.75 0 0 1 .02-1.08Z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>

                    <input
                        class="w-full min-w-0 bg-transparent px-3 py-2.5 text-sm tabular-nums text-slate-900 placeholder:text-slate-400 focus:outline-none sm:text-base"
                        type="tel"
                        [value]="value.phone"
                        (input)="onPhoneChange($any($event.target)?.value)"
                        (blur)="onTouched()"
                        [placeholder]="placeholder"
                        [disabled]="disabled"
                    />
                </div>

                <div
                    *ngIf="countryMenuOpen"
                    class="absolute left-0 right-0 top-full z-[1000] mt-2 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl"
                    role="listbox"
                >
                    <div class="border-b border-slate-200 bg-white p-2">
                        <input
                            #countrySearch
                            type="text"
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:border-[#6e9bad] focus:outline-none"
                            placeholder="Search country or code"
                            [value]="countrySearchQuery"
                            (input)="onCountrySearch($any($event.target)?.value)"
                            (keydown.escape)="closeCountryMenu()"
                            [disabled]="disabled"
                        />
                    </div>
                    <div class="max-h-[min(18rem,50vh)] overflow-auto p-1">
                        <button
                            *ngFor="let c of filteredCountries; trackBy: trackByCountryCode"
                            type="button"
                            class="flex w-full min-w-0 items-center gap-2 rounded-xl px-3 py-2 text-left text-sm transition hover:bg-slate-50"
                            [class.bg-slate-100]="c.code === value.countryCode"
                            (click)="selectCountry(c.code)"
                            [disabled]="disabled"
                        >
                            <span class="inline-flex h-5 w-5 shrink-0 items-center justify-center text-base leading-none" aria-hidden="true">
                                {{ c.flag }}
                            </span>
                            <span class="min-w-0 flex-1 truncate text-slate-900">{{ c.name }}</span>
                            <span class="shrink-0 text-xs font-semibold text-slate-500">{{ c.dial_code }}</span>
                        </button>

                        <div *ngIf="!filteredCountries.length" class="px-3 py-6 text-center text-sm text-slate-500">
                            No matches
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
